var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { SPACING_XL } from "../../../../helpers";
var ICON_SIZE = '20px';
export var VERTICAL_PADDING = (parseInt(SPACING_XL, 10) - parseInt(ICON_SIZE, 10)) / 2 + "px";
export var MODE;
(function (MODE) {
    MODE["noSelected"] = "noSelected";
    MODE["selected"] = "selected";
})(MODE || (MODE = {}));
export var CentralCircle = styled.circle(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var RadiobuttonIconWrapper = styled.svg(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    min-width: ", ";\n"], ["\n    min-width: ", ";\n"])), ICON_SIZE);
export var RadiobuttonIcon = function (_a) {
    var _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, _c = _a.isError, isError = _c === void 0 ? false : _c, _d = _a.mode, mode = _d === void 0 ? MODE.noSelected : _d, rest = __rest(_a, ["isDisabled", "isError", "mode"]);
    return (React.createElement(RadiobuttonIconWrapper, { "data-selector-id": rest['data-selector-id'] || 'radiobutton-icon', viewBox: "0 0 20 20", width: "20px", height: "20px", isDisabled: isDisabled, isError: isError },
        React.createElement("circle", { fill: "currentColor", cx: "10", cy: "10", r: "9" }),
        mode === MODE.selected && React.createElement(CentralCircle, { cx: "10", cy: "10", r: "5" }),
        React.createElement("path", { d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm0,19a9,9,0,1,1,9-9A9,9,0,0,1,10,19Z" })));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=RadiobuttonIcon.js.map